export default __webpack_public_path__ + "static/media/continuing-main.61cc7564.jpg";